type HttpHeaders = {
  [key: string]: string | undefined;
  Authorization?: string;
};

export const fetchWithTimeout = async (
  resource: string,
  timeout: number,
  headers?: HttpHeaders,
) => {
  const abortController = new AbortController();
  const id = setTimeout(() => abortController.abort(), timeout);

  const options = {
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  const response = await fetch(resource, {
    ...options,
    signal: abortController.signal,
  });
  clearTimeout(id);

  return response;
};
